const initialState = {
	data: [],
	total: 0,
	params: {},
	selected: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const rewardhistory = (state = initialState, action) => {
	switch (action.type) {
		case 'AFFILIATE_REWARD_HISTORY_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'AFFILIATE_REWARD_HISTORY_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'AFFILIATE_REWARD_HISTORY_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'AFFILIATE_REWARD_HISTORY_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'AFFILIATE_REWARD_HISTORY_GET_CURRENT':
			return {
				...state,
				selected: action.selected,
			}
		case 'AFFILIATE_REWARD_HISTORY_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default rewardhistory
